<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!scanproId">Add Zone Scan Pro Master</span>
                <span *ngIf="scanproId">Update Zone Scan Pro Master</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="zoneScanProForm" (submit)="createZoneScanPro()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Circle *</label>
                                    <mat-select (selectionChange)="getCircleZone($event.value)" placeholder="Circle"
                                        formControlName="circle_id" (click)="setSearchValue('circle')">
                                        <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'circle')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="circleSearch">
                                        <mat-option>All</mat-option>
                                        <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Zone *</label>
                                    <mat-select placeholder="Zone"
                                        formControlName="zone_id" (click)="setSearchValue('zone')">
                                        <input class="mySearchInput" #zoneSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'zones')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="zoneSearch">
                                        <mat-option [value]="zone.id" *ngFor="let zone of zones">
                                            {{zone.zone_name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.zone_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.zone_id.errors.required">Zone is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">ScanProUser *</label>
                                    <mat-select placeholder="Select Scan Pro User" (click)="setSearchValue('scanpro')"
                                        formControlName="scanprouser_id">
                                        <input class="mySearchInput" #scanproSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'scanpro')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="scanproSearch">
                                        <mat-option [value]="scanpro.id" *ngFor="let scanpro of allscanproUser">
                                            {{scanpro.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.scanprouser_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.scanprouser_id.errors.required">Scan pro is required</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th class="td1">
                                        <button type="button" class="btn btn-success btn-sm" (click)="addQuantity()">
                                            Booking Days <i class="fa fa-plus" aria-hidden="true"></i></button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <div class="col-sm-12" formArrayName="bookingDays" style="display: contents;">
                                    <tr *ngFor="let quantity of bookingDays().controls; let i=index"
                                        [formGroupName]="i">
                                        <td class="td1">
                                            <div class="col">
                                                <label class="form-label">Days List:</label>
                                                <mat-select placeholder="Select Days" formControlName="days_list">
                                                    <mat-option *ngFor="let days of this.daysList" [value]="days.value">
                                                        {{days.name}}
                                                    </mat-option>
                                                </mat-select>
                                            </div>
                                        </td>
                                        <td class="td1">
                                            <div class="col">
                                                <label class="form-label">No.of Booking:</label>
                                                <input type="text" class="form-control" placeholder="No.of Booking"
                                                    formControlName="no_of_booking" />
                                            </div>
                                        </td>
                                        <td class="td1">
                                            <div class="col">
                                                <label class="form-label">From Time:</label>
                                                <input type="time" class="form-control" placeholder="From Time"
                                                    formControlName="from_time" />
                                            </div>
                                        </td>
                                        <td class="td1">
                                            <div class="col">
                                                <label class="form-label">To Time:</label>
                                                <input type="time" class="form-control" placeholder="To Time"
                                                    formControlName="to_time" />
                                            </div>
                                        </td>
                                        <td class="td1">
                                            <button class="btn btn-danger mt-5" mwlConfirmationPopover
                                                [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage"
                                                [confirmText]="confirmText" [cancelText]="cancelText"
                                                [placement]="placement" (confirm)="removeQuantity(i)"
                                                (cancel)="cancelClicked = true" confirmButtonType="danger"
                                                cancelButtonType="outline-secondary"
                                                (click)="confirmClicked = false; cancelClicked = false"
                                                [appendToBody]="true">
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!scanproId">Create Zone Scan Pro</span>
                        <span *ngIf="scanproId">Update Zone Scan Pro</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>